import { IGlocalConfiguration } from '#/CoreFrameInterfaces';

export default {
    visitedModules: ["Base"],
    listView: {
        ShowToolbarText: true,
        ShowCountInHeader: true,
        toolbarHeight: 34,

        filterConfiguration: {
            filterOperatorSortingStrategy: (operators: Array<{ ergName: string, value: string }>) => null
        }
    },
    filterView: {
        elementHeight: 29
    },
    detailView: {
        AlwaysCloseDetailViewContext: true,
        ShowNoLastSavedViewAfterDVC: false
    },
    viewExtension: {
        ShowContextHeader: true
    },
    dataGrid: {
        ShowCountInFooter: true,
        MinHeightForAssociationGridInDV: 185,
        HeightForAssociationGridInDV: '185px',
        SortingClickStrategy: 'kendo'
    },
    headerView: {
        showApplicationSearch: true,
        showDarkModeSwitch: true,
        usePrincipalLogoAsCompanyHeader: false
    },
    multiLineTextBox: {
        MinHeight: 120,
        DefaultHeight: 120
    },
    summaryView: {
    },
    inlineImages: {
        // DV
        OBJ_SELECT: 'link.svg',
        OBJ_CREATE: 'add.svg',
        OBJ_DELETE: 'garbage.svg',
        OBJ_EDIT: 'pencil.svg',
        OBJ_DISCONNECT: 'link_broken.svg',
        
        TOOLBAR_SAVE: 'cloud_upload.svg',
        TOOLBAR_ABORT: 'delete.svg',
        TOOLBAR_APPLY: 'check.svg',
        TOOLBAR_OPERATION: 'media_play.svg',

        MOVE_UP: 'arrow_up.svg',
        MOVE_DOWN: 'arrow_down.svg',

        MLSTRING_EDIT: 'message.svg',

        // LV / Grid
        FILTER: 'funnel.svg',
        FILTER_OFF: 'c_funnel_off.svg',
        PUBLIC_FILTER_EDIT: 'filter_public_edit.svg',
        TOOLBAR_SELECT: 'link.svg',
        TOOLBAR_CREATE: 'add.svg',
        TOOLBAR_DELETE: 'garbage.svg',
        TOOLBAR_EDIT: 'pencil.svg',
        TOOLBAR_DISCONNECT: 'link_broken.svg',
        TOOLBAR_FILTER: 'lv_find.png',
        TOOLBAR_TABLECONFIG: 'table_selection_column.svg',

        REFRESH: 'arrow_circle2.svg',

        MEDIUM_SELECT: 'open_file.svg',
        MEDIUM_DOWNLOAD: 'download_file.svg',
        MEDIUM_DELETE: 'delete_file.svg',
        MEDIUM_VIEWFILE: 'view_file.svg',

        MEDIUM_UPLOAD: 'upload.svg',
        MEDIUM_UPLOAD_NOTALLOWED: 'upload_notallowed.svg',
		
        TEXTBOX_POPUP: 'arrow_spread.png',
        OPEN_FULLSCREEN: 'arrow_spread.png',
        SHOW_TASKS: 'head_tasks.svg',
        NAVIGATE_LEFT: 'navigate_left.svg',
        NAVIGATE_LEFT_ALL: 'navigate_left2.svg',
        NAVIGATE_RIGHT: 'navigate_right.svg',
        NAVIGATE_RIGHT_ALL: 'navigate_right2.svg',
        LOGIN_KEY: 'login.svg',
        TWOFA_LOCK: '2fa_lock.svg',

        DATEPICKER: 'datepicker.png',
        ASSOCIATION_OBJ: 'association_object.png',
        WINDOW_CANCEL: 'window_cancel.png',
        WINDOW_OK: 'window_ok.png',
        FILE_SAVE: 'save_file.png',
        DV_SAVE: 'cloud_upload.svg',
        CHANGE_VIEW: 'union.png',
        OPEN_URL: 'stack_spacer.png',
        EXPANDER_EXPAND: 'expander-expand.svg',
        EXPANDER_COLLAPSE: 'expander-collapse.svg',
        USER_RECYCLE: 'userRecycle.png',
        APPLY_OFF: 'selection_apply_off.png',
        CANCEL_OFF: 'delete.svg',
        TIMEPICKER: 'clock.svg',
        RESET: 'revert.svg',
        PICKER: 'calendar.svg',
        MENU_HOME: 'home.svg',
        MENU_INFO: 'info_pikto.png',
        INFO_DARK: 'info_dark.png',
        LV_APPLY: 'check.svg',
        LV_ABORT: 'delete.svg',
        ELEMENTS4: 'elements4.png',
        SORT_AZ: 'sort_az_descending.png',
        MAGNIFYING_GLASS: 'magnifying_glass.png',
        GEAR: 'gearwheel.svg',
        GEARWHEELS: 'gearwheels.svg',
        NAV_LEFT_CIRCLE: 'nav_left_circle.png',
        NAV_RIGHT_CIRCLE: 'nav_right_circle.png',
        LDAP_USER_IMPORT: 'ldapImport.png',
        PRINCIPALS_CURRENT: 'principals_current.png',
        PRINCIPALS_CURRENT_SUB: 'principals_current_sub.png',
        PRINCIPALS_SUB: 'principals_sub.png',
        CUSTOM_SEARCH_ACTIVATED: 'custom_search_activated.png',
        CUSTOM_SEARCH_DEACTIVATED: 'custom_search_deactivated.png',
        XLS_DOCUMENT: 'lv_XLS_document.svg',
        CSV_DOCUMENT: 'lv_CSV_document.svg',
        TWOFA_INFO: 'info_pikto.png',
        FAVORITES: 'favorites.svg',
        COMPANY_HEADER_LOGO_SMALL: 'CompanyHeaderLogoSmall.svg',
        COMPANY_HEADER_LOGO_BIG: 'CompanyHeaderLogoBig.svg',
        NOTICE_MESSAGE_ICON: 'message_notice.png',
        MYTASKS: 'myTasks.png',
        UNASSIGNEDTASKS: 'UnassignedTasks.png',
        ALLTASKS: 'allTasks.png',
        TASK: 'task.png',
        
        FAVOURITE_ACTIVE: 'star_enabled.svg',
        FAVOURITE_INACTIVE: 'star_disabled.svg',
    },
    window: {
        ShowMessageWindowCrossButton: false
    },
    clientCache: {
        showLoaderOnUpdate: true
    }
} as IGlocalConfiguration;